module.exports = __webpack_public_path__ + "static/img/case3.e1bcc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/case3.png
// module id = tTZr
// module chunks = 1